"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * エラーハンドリングルート部品
 */
const ErrorCatchRoute = function (props) {
  return /*#__PURE__*/_react.default.createElement(_ErrorBoundary.default, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, props));
};
var _default = exports.default = ErrorCatchRoute;